import styled from 'styled-components';

interface TableWrapperProps {
  $exporting?: boolean;
}

export const TableWrapper = styled.div<TableWrapperProps>`
  /* display: flex; */
  /* justify-content: center; */

  /* margin: auto; */
  /* overflow-x: auto; */
  /* width: 100%; */

  @media screen and (max-width: 1900px) {
    .table {
      width: 100%;
    }
  }

  .table {
    word-break: keep-all;

    .th,
    .td {
      text-align: center;
      /* border: 1px solid #f0f0f0; */
      position: relative;
    }
    .body {
      .th,
      .td {
        min-height: 46px;
      }
      .child-row {
        .th,
        .td {
          min-height: 60px;
        }
      }
    }
    .th {
      /* background: white; */
      min-width: 100px;
      vertical-align: middle;

      /* &.active {
        z-index: 2;
        background-color: #ffe3da !important;
      } */
    }

    /* .header {
      .th,
      .td {
        background: ${({ theme }) => theme.palette.gray.light};

        &:nth-child(odd) {
          background: #eee;
        }
      }
    } */

    .body {
      .th,
      .td {
        padding-left: 10px;
        padding-right: 10px;
      }
    }

    .tr {
      &.gray-scale-row {
        filter: grayscale(100);
        -webkit-filter: grayscale(100);
        -moz-filter: grayscale(100);
        -o-filter: grayscale(100);
        -ms-filter: grayscale(100);
        background-color: red;
      }

      &:hover {
        /* background-color: rgba(255, 178, 152, 0.3) !important; */
        /* .td:first-child {
        background-color: #ffe3da;
      } */
        .td {
          background-color: transparent;
        }
      }
    }

    .tr:nth-child(odd) .td {
      border-bottom: 1px solid #f0f0f0;
      background: #fff;

      /* &.active {
        background-color: #ffe3da;
      }

      &:hover {
        background-color: rgba(255, 178, 152, 0.3);
      } */
    }

    .tr:nth-child(even) .td {
      border-bottom: 1px solid #f0f0f0;
      background: #f5f5f5;

      /* &.active {
        background-color: #ffe3da;
      }

      &:hover {
        background-color: rgba(255, 178, 152, 0.3);
      } */
    }

    .tr:first-child {
      .th:first-child {
        z-index: auto;
      }
    }

    .td {
      background-color: white;
      position: relative;
      /* &.active {
        z-index: 1;
        background-color: rgba(255, 178, 152, 0.3) !important;
        &:hover {
          z-index: 10;
        }
      } */
      &:first-child {
        padding-left: 30px;
        text-align: left;
      }
      &.aggregated {
        /* background-color: #f5f5f5; */
      }
    }
    &.sticky {
      //overflow-x: scroll;
      .header {
        margin-left: auto;
        margin-right: auto;
        position: ${props => (props.$exporting ? 'static' : 'sticky')};
        z-index: 10;
        width: fit-content;
        box-shadow: 0 3px 3px #ccc,
          0 -4px 0 ${({ theme }) => theme.custom.colors.brand};
        top: 40px;
      }

      .body {
        position: relative;
        z-index: 0;
      }

      .tr {
        margin-left: auto;
        margin-right: auto;
      }

      /* [data-sticky-td] {
        position: sticky;
      } */

      [data-sticky-last-left-td] {
        box-shadow: 1px 0 1px #ccc;
        /* &.active {
          background-color: #ffe3da !important;
        } */
      }

      [data-sticky-first-right-td] {
        box-shadow: -2px 0 3px #ccc;
      }
    }
  }
`;

export const Monospace = styled.span`
  font-family: Consolas, 'Courier New', monospace;
  font-weight: bold;
  margin-top: 4px;
  white-space: normal;
`;

export const Normal = styled.span`
  font-weight: normal;
`;

export const HeaderCell = styled.div<{
  $zIndex?: number | 'auto';
  breakAll?: boolean;
  $group?: boolean;
  $center?: boolean;
}>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 5px;
  ${({ $group }) => !$group && `align-items: center;`}
  ${({ $center }) => $center && `justify-content: center;`}
  hyphens: auto;
  ${({ $zIndex }) => $zIndex && `z-index: ${$zIndex};`}
  color: ${({ theme }) => theme.custom.colors.gray800};
  ${({ $group }) =>
    $group && `font-family: Consolas, 'Courier New', monospace;`}
  font-size: 14px;
  font-style: normal;
  ${({ $group }) => $group && `font-weight: 700;`}
  line-height: 20px;
  min-height: 0;
  padding: 20px;
  padding-bottom: ${({ $group }) => ($group ? '0' : '8px')};
  padding-top: ${({ $group }) => ($group ? '14px' : '8px')};
  ${({ $group }) => $group && `text-transform: uppercase;`}
  height: 100%;
  text-align: ${({ $center }) => ($center ? 'center' : 'left')};
  width: 100%;

  svg {
    display: none;
    margin-top: 2px;
  }

  @media screen and (max-width: 48em) {
    display: block;
    & > * {
      margin-left: 3px;
    }
  }
`;

export const PrintHeaderCell = styled(HeaderCell)`
  hyphens: none;
  white-space: normal;
  word-break: ${props => (props.breakAll ? 'break-all' : 'break-word')};
`;

export const linkIconStyle = { marginLeft: '5px' };
export const tooltipIconStyle = { color: '#999', cursor: 'help' };

export const Legend = styled.div`
  width: 100%;
  position: relative;
  margin-top: 100px;
  padding: 0px 10px;
  -moz-column-count: 4;
  -moz-column-gap: 2%;
  -moz-column-width: 22%;
  -webkit-column-count: 4;
  -webkit-column-gap: 2%;
  -webkit-column-width: 22%;
  column-count: 4;
  column-gap: 2%;
  column-width: 22%;
`;

export const LegendItem = styled.div`
  position: relative;
  padding: 10px;
  break-inside: avoid-column;
`;

export const HeaderName = styled.h4`
  font-weight: 700;
  margin: 0px;
`;

export const ItemTooltip = styled.p`
  margin: 5px 0px;
`;

export const ExportContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
`;
